import {getStorages} from './engine'

export type StorageDump = Record<string, string>


/* eslint-disable class-methods-use-this */
export class StorageBackup {
    private listeners: Set<() => void> = new Set()

    public attachStorageListener = (callback: () => void) => {
        this.listeners.add(callback)
    }

    public notifyStorageChange = (): void => {
        this.listeners.forEach((callback) => {
            try {
                callback()
            } catch {} // eslint-disable-line no-empty
        })
    }

    public dumpStorage = (persist?: boolean) => {
        const storages = getStorages(persist)
        const storage = storages[persist ? 1 : 0]
        const out: StorageDump = {}
        if (!storage) {
            return out
        }
        try {
            for (let i = 0; i < storage.length; i += 1) {
                const key = storage.key(i)
                if (key !== null) {
                    out[key] = storage.getItem(key) ?? ''
                }
            }
        } catch {} // eslint-disable-line no-empty
        return out
    }

    public restoreStorage = (persist: boolean, dump: any): void => {
        const storages = getStorages(persist)
        const storage = storages[persist ? 1 : 0]
        if (!storage) {
            return
        }
        try {
            Object.entries(dump ?? {}).forEach(([key, value]) => {
                storage.setItem(key, value as string)
            })
        } catch {} // eslint-disable-line no-empty
    }
}

export default new StorageBackup()
